<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="splashPage">
        <v-layout column justify-center align-center>
          <div class="splashInnerPnl">
            <v-flex>
              <h2>{{ projectTitle }}</h2>
            </v-flex>
            <v-flex v-if="loading">
              <v-progress-circular indeterminate v-bind:size="50" color="primary"></v-progress-circular>
            </v-flex>
            <v-flex v-else>
              <v-btn color="primary" @click="reloadPage">Reload Application</v-btn>
            </v-flex>
            <v-flex class="pt-3">
              {{ loadingMessage }}
            </v-flex>
          </div>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  data() {
    return {}
  },
  computed: {
    projectTitle() {
      return this.$store.state.app.projectTitleLong
    },
    loadingMessage() {
      return this.$store.state.app.initMessage
    },
    loading() {
      if (this.$store.state.app.init === 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    reloadPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.splashPage {
  content: '';
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-image: url('/static/img/login-bg.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  .splashInnerPnl {
    text-align: center;
    width: 50%;
    padding: 5%;
    background: hsla(0, 0%, 100%, 0.3);
    position: absolute;
  }
}
h2 {
  font-size: 2.3em;
  font-weight: 500;
}
</style>
